export function resolveCompanySlug(
  companySlug?: string | null,
  urlSlug?: string | null
): string | null {
  const fromCompany = companySlug?.trim();
  if (fromCompany && fromCompany.toLowerCase() !== "demo") {
    return fromCompany;
  }

  const fromUrl = urlSlug?.trim();
  if (fromUrl && fromUrl.toLowerCase() !== "demo") {
    return fromUrl;
  }

  const stored =
    localStorage.getItem("company_slug") ||
    sessionStorage.getItem("company_slug");
  if (stored && stored.toLowerCase() !== "demo") {
    return stored;
  }

  return null;
}

export function getCompanySlugFromPath(): string | null {
  const pathParts = window.location.pathname.split("/");
  const companyIndex = pathParts.findIndex((part) => part === "client") + 1;
  const slug = pathParts[companyIndex];
  if (!slug || slug.toLowerCase() === "demo" || slug === "admin") {
    return null;
  }
  return slug;
}
